"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How long does it take to build my website?",
  answer: "We pride ourselves on fast turnaround times. Typically, we can have your full website built and ready to launch in as little as 14 days, provided we have all the necessary information and content from you."
}, {
  question: "What is included in the monthly hosting fee?",
  answer: "Our $39/month + GST hosting and maintenance fee covers secure high-speed hosting, SSL security certificates, regular software updates, and daily backups. It also includes ongoing support, so if you need small text or image changes, we handle them for you."
}, {
  question: "Do I need to provide my own content?",
  answer: "You can provide your own text if you prefer, but we also offer a Content Creation Add-On. This includes professional photography, videography, and copywriting services to ensure your website looks and sounds professional."
}, {
  question: "Is there a lock-in contract?",
  answer: "Our website packages come with a minimum 12-month hosting term. This allows us to offer the initial build at such a competitive price. After the first 12 months, the service continues on a month-to-month basis."
}, {
  question: "Will my website work on mobile phones?",
  answer: "Absolutely. All our websites are fully responsive and mobile-friendly. We design with a mobile-first approach to ensure your site looks great and functions perfectly on smartphones, tablets, and desktops."
}, {
  question: "Can you help with SEO?",
  answer: "Yes, all our packages include basic SEO optimization. We set up your site structure, meta tags, and content to be search-engine friendly. For more advanced local SEO strategies, we can discuss additional options to help you rank higher."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="frequently-asked-questions" className="bg-background text-foreground py-20 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[10%] left-[10%] w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[10%] right-[10%] w-80 h-80 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={cn("relative z-10 max-w-3xl mx-auto transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-sans text-foreground mb-4 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg">
            Everything you need to know about our web design packages.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border border-border/40 bg-card/30 backdrop-blur-sm rounded-xl px-6 overflow-hidden data-[state=open]:border-primary/30 transition-colors duration-300" data-index={i}>
              <AccordionTrigger className="text-left text-base md:text-lg font-bold font-sans text-foreground hover:text-primary transition-colors py-6 [&>svg]:text-primary [&>svg]:size-5 [&>svg]:stroke-[3px]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}